function normalizeUrl(rawUrl) {
    const url = String(rawUrl || '').trim();
    if (!url) return '';
    if (/^(https?:)?\/\//i.test(url) || /^(mailto:|tel:|tg:|whatsapp:)/i.test(url)) {
        return url;
    }
    if (url.startsWith('/')) {
        return url;
    }
    return `https://${url}`;
}

export function openUrl(rawUrl, router) {
    const url = normalizeUrl(rawUrl);
    if (!url) {
        return false;
    }
    if (url.startsWith('/')) {
        if (router) {
            router.push(url);
        } else {
            window.location.href = url;
        }
        return true;
    }
    if (window.plus && window.plus.runtime && typeof window.plus.runtime.openURL === 'function') {
        window.plus.runtime.openURL(url);
        return true;
    }
    window.location.href = url;
    return true;
}

export function openServiceUrl(rawUrl, router, fallback = '/service') {
    if (openUrl(rawUrl, router)) {
        return true;
    }
    if (router && fallback) {
        router.push(fallback);
        return true;
    }
    return false;
}
